export default __webpack_public_path__ + "static/media/rolesUXDesign.d8e0ceee.svg";